import { BackgroundColorName } from "@/helpers/mapBackgroundColor";
import BackgroundColorWrapper from "./BackgroundColorWrapper";
import HeaderOffsetPaddingWrapper from "./HeaderOffsetPaddingWrapper";
import HorizontalPaddingWrapper from "./HorizontalPaddingWrapper";
import VerticalPaddingWrapper, { VerticalPaddingValues } from "./VerticalPaddingWrapper";
export { BackgroundColorWrapper, HorizontalPaddingWrapper, VerticalPaddingWrapper };

export type FormattingOptions = {
  backgroundColorName?: BackgroundColorName;
  paddingTop?: VerticalPaddingValues;
  paddingBottom?: VerticalPaddingValues;
  addHeaderOffsetPadding?: boolean;
}

export type FormattingWrapperProps = FormattingOptions & {
  children: React.ReactNode;
}

/*
 * A standardized wrapper for most common component formatting options, 
 * and application of standard padding. 
 */

const FormattingWrapper = ({ children, backgroundColorName, paddingTop, paddingBottom, addHeaderOffsetPadding = false }: FormattingWrapperProps) => {
  // Do not return empty <BackgroundColorWrapper> div if backgroundColor is not provided
  return backgroundColorName ? (
    <BackgroundColorWrapper backgroundColorName={backgroundColorName}>
      {addHeaderOffsetPadding && <HeaderOffsetPaddingWrapper />}
      <HorizontalPaddingWrapper>
        <VerticalPaddingWrapper paddingTop={paddingTop} paddingBottom={paddingBottom}>
          {children}
        </VerticalPaddingWrapper>
      </HorizontalPaddingWrapper>
    </BackgroundColorWrapper >
  ) : (
    <HorizontalPaddingWrapper>
      {addHeaderOffsetPadding && <HeaderOffsetPaddingWrapper />}
      <VerticalPaddingWrapper paddingTop={paddingTop} paddingBottom={paddingBottom}>
        {children}
      </VerticalPaddingWrapper>
    </HorizontalPaddingWrapper>
  )
}

export default FormattingWrapper;
